import BaseService from '../BaseService';
import UserApiAgency from '@/api/UserApiAgency';
import UserApi from '@/api/UserApi';

class UserService extends BaseService {
	async getUserInfosAsync (...args: Parameters<typeof UserApi.getUserInfos>) {
		try {
			const { data } = await UserApi.getUserInfos(...args);
			return data;
		} catch {
			return undefined;
		}
	}

	async sendMailResetPasswordAsync (...args: Parameters<typeof UserApi.sendMailResetPassword>) {
		const { data } = await UserApi.sendMailResetPassword(...args);
		return data;
	}

	async updateAsync (...args: Parameters<typeof UserApi.update>) {
		const { data } = await UserApi.update(...args);
		return data;
	}

	async sendEmailActivationAsync (...args: Parameters<typeof UserApi.sendEmailActivation>) {
		const { data } = await UserApi.sendEmailActivation(...args);
		return data;
	}

	async sendEmailConfirmationTempWorkerAsync (...args: Parameters<typeof UserApiAgency.sendEmailConfirmationTempWorker>) {
		if (this.self.isAgency()) {
			const { data } = await UserApiAgency.sendEmailConfirmationTempWorker(...args);
			return data;
		};
	}

	async getUserFullInfosAsync (...args: Parameters<typeof UserApi.getUserFullInfos>) {
		const { data } = await UserApi.getUserFullInfos(...args);
		return data;
	}

	async addAsync (...args: Parameters<typeof UserApi.add>) {
		const { data } = await UserApi.add(...args);
		return data;
	}
}

export default function useUserService () {
	return new UserService();
}
